import { AlertStateEntry } from "./../model/alert-state-entry";
import { IHistoryResponse, IHistoryItem, IPeriodsUpdate } from "./historyItem";
import { IQuotaData } from "./quote.data";
import { ReadModelAsStringFloatingFilterComp } from "ag-grid/dist/lib/filter/floatingFilter";
import { SymbolTypeEnum } from "../enums/SymbolType.enum";
import { AccountWS } from "../model/account.data";
import { Alert } from "../model/alert";

export interface IServiceResponse {
    Type?: string;
    Text?: string;

    OrderUpdate?: any;
    Trade?: any;
    TradeHistory?: any;
    IsLoggedIn?: any;
    T?: IQuotaData[];
    P?: IPeriodsUpdate[];
    Period?: number;
    ReqID?: string;
    Symbol?: string;
    Periods?: IHistoryItem[];
    Data?: IServiceResponse[];
}

export class LoginRs {
    Type: string = "";
    OK: boolean = false;
    SessionKey: string = "";
    SymbolInfoes: ISymbolInfo[] = [ { Symbol: "", Type: SymbolTypeEnum.Unknown, Decimals: 3, MarginPerc: 3.33 } ];
    Settings: { Key: string; Setting: string }[] = [];
    Accounts: AccountWS[] = [];
    ActiveAccountId: number = 0;
    HasAlertsAccess: boolean = false;
    Alerts: Alert[] = [];
    AlertStateEntries: AlertStateEntry[] = [];
    UserId: number = -1;
    UserType: string = "";
    FirstLogin = false;
    Tags?: number[];
    ApplicationUserType: string = "";
    UserName: string = "";
    Password: string = "";
    IsProviderBound?:boolean = false;
    Provider?:string;
    ProviderAccounts?:any[];
    ProviderInstruments?: {Symbol: string; MarginPercentage: number;}[];
}

export class SwitchProviderRs{
    ProviderInstruments?: {Symbol: string; MarginPercentage: number;}[];
}
export class RestoreSessionRs {
    Type: string = "";
    Error: string = "";
}

export interface ITournamentRegisterRs {
    Type: string;
    Error: string;
}

export interface IRenameAccountRq { }

export interface ILeaderBoardReq {
    TournamentId: number;
}

export interface IChangePasswordReq {
    OldPassword: string;
    NewPassword: string;
}

export interface IChangePasswordRs {
    Type: string;
    Error: string;
}

export interface IRestoreSessionRequest {
    SessionKey: string;
}

export interface ILeaderBoardRs {
    ContestantResults: ILeaderBoardPosition[];
    TournamentId: number;
    TournamentType?: string;
}

export interface IPreviousChallengesResponse {
    Challenges: historyChallenge[]
}

export interface historyChallenge {
    AccountId: number
    AccountName: string
    ChallengeName: string
    EndDateUTC: string
    Id: number
    StartDateUTC: string
    StartingBalance: number
}

export interface ILeaderBoardPosition {
    UserId: number;
    AccountId: number;
    Place: number;
    AccountName: string;
    PnL: number;
    Pips?: number;
    IsCurrentUser: boolean;
}

export class SettingsRs {
    Type: string = "";
    UserSettings: { Key: string; Setting: string }[] = [];
}

export class OrderRs {
    Type: string = "";
    OK: boolean = false;
    Id: string = "";
    Currency: string = "";
    Error: string = "";
    LimitPrice: number = 0;
    OrderType: string = "";
    Quantity: number = 0;
    Side: string = "";
    StopPrice: number = 0;
}

export class CancelRs {
    Type: string = "";
    OK: boolean = false;
    Id: string = "";
    Currency: string = "";
    Error: string = "";
    LimitPrice: number = 0;
    Quantity: number = 0;
    Side: string = "";
    StopPrice: number = 0;
}

export interface PartialCloseRs {
    Type: string;
    Error: string;
    FillPrice: number;
    Pips: number;
    Profit: number;
    Qty: number;
    Symbol: string;
}
export class ISymbolInfo {
    Symbol: string = "";
    Type: SymbolTypeEnum = SymbolTypeEnum.Unknown;
    Decimals: number = 0;
    MarginPerc: number = 0;
}

export interface ISymbolOneClick {
    enabled: boolean;
    volume: number;
    label: string;
}

export interface TradeLines {
    Type: string;
    Lines: IOrdersData[];
    MoneyLine: MoneyLine;
    HistoryLines: IOrdersHistoryData[];
}
export interface PrevChallengeTradeHistoryRs {
    Type: string;
    HistoryLines: IOrdersHistoryData[];
}



export interface IOrdersHistoryData {
    EntryTime: string;
    CloseTime: string;
    Ticket: string;
    Type: string;
    Qty: string;
    Symbol: string;
    EntryPrice: string;
    Stop: string;
    Limit: string;
    ClosePrice: string;
    Pips: string;
    PnLUSD: string;
}

export class OrdersHistoryDataImpl implements IOrdersHistoryData
{
    EntryTime: string = "";
    CloseTime: string = "";
    Ticket: string = "";
    Type: string = "";
    Qty: string = "";
    Symbol: string = "";
    EntryPrice: string = "";
    Stop: string = "";
    Limit: string = "";
    ClosePrice: string = "";
    Pips: string = "";
    PnLUSD: string = "";
}

export interface MoneyLine {
    Balance: number;
    MarginInUse: number;
    SumOfPips: number;
    SumOfUPLUSD: number;
    SumOfPipsHistory: number;
    SumOfPLUSDHistory: number;
    PnL: number;
    AccountValue: number;
}

export interface IOrdersData {
    ID: number;
    Symbol: string;
    Ticket: string;
    EntryTime: string;
    Type: string;
    Qty: number;
    EntryPrice: number;
    Stop: number;
    Limit: number;
    MarketPrice: number;
    Pips: number;
    PnLUSD: number;
    EditRq: IEditRq;
    MenuRequests: string[];
    Trailing:number;
}

export interface IEditRq {
    Currency: string;
    Id: number;
    LimitPips: number;
    LimitPrice: number;
    Quantity: number;
    Side: string;
    StopPips: number;
    StopPrice: number;
    Type: string;
}

export interface TradeClosedRs {
    FillPrice: number;
    Pips: number;
    Profit: number;
    Qty: number;
    Symbol: string;
    Type: string;
}

export interface PositionEnteredRs {
    Type: string;
    Symbol: string;
    Side: string;
    Quantity: number;
    AvgFillPrice: string;
}

export interface SetAlertReadRq {
    AlertId: number;
}

export interface NewAlert {
    Alert: Alert;
}

export interface AlertRead {
    AlertId: number;
}

export interface AlertStateChanged {
    AlertStateEntry: AlertStateEntry;
}
